import { ParkingContainer } from '../../containers/advancedFilters/ParkingContainer';
import { IFilter } from '../../types/filters';

export const parking: IFilter = {
  component: ParkingContainer,
};
